module.exports = __webpack_public_path__ + "static/img/cont44_10.adf354a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont44_10.jpg
// module id = fdpJ
// module chunks = 0